import { Injectable } from "@angular/core";
import { CanActivateChild, Router, UrlTree } from "@angular/router";
import { Observable } from "rxjs";
import { AuthService } from "../services/auth.service";

@Injectable({
  providedIn: "root",
})
export class AuthGuard implements CanActivateChild {
  constructor(private readonly _authService: AuthService, private readonly _router: Router) {}

  canActivateChild(): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
    return this._authService.isAuthorized() || this._router.createUrlTree(["/auth"]);
  }
}
